import * as xlsx from 'xlsx'

export class XLSXWriter {
    constructor ({ name = 'Andamanda-Report', title = 'Andamanda', subject = 'Report', author = 'Andamanda' }) {
        this.name = name
        this.title = title
        this.subject = subject
        this.author = author
        this.headers = []
        this.rows = []
    }

    setHeaders (headers) {
        this.headers = headers
        return this
    }

    setRows (rows) {
        this.rows = rows
        return this
    }

    addRow (row) {
        this.rows.push(row)
        return this
    }

    addHeader (header) {
        this.headers.push(header)
        return this
    }

    getXlsxBlob () {
        this.workbookObj = xlsx.utils.book_new()
        this.workbookObj.Props = {
            Title: this.title,
            Subject: this.subject,
            Author: this.author,
            CreatedDate: new Date()
        }
        this.workbookObj.SheetNames.push(this.name)
        this.workbookObj.Sheets[this.name] = xlsx.utils.aoa_to_sheet(this._getSheetDataArray())

        const workbookOut = xlsx.write(this.workbookObj, { bookType: 'xlsx', type: 'binary' })
        const sheetArrayBuffer = this._sheetToArrayBuffer(workbookOut)

        return new Blob([sheetArrayBuffer], { type: 'application/octet-stream' })
    }

    _getSheetDataArray () {
        return [this.headers, ...this.rows]
    }

    _sheetToArrayBuffer (sheet) {
        const buffer = new ArrayBuffer(sheet.length)
        const view = new Uint8Array(buffer)
        for (let i = 0; i < sheet.length; i++) {
            view[i] = sheet.charCodeAt(i) & 0xFF
        }
        return buffer
    }
}
